import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule as MatAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { Overlay } from '@angular/cdk/overlay';

import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TreoCardModule } from 'tsui/@treo';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { NgxFilesizeModule } from 'ngx-filesize';

import { ContactsModalModule } from 'app/modules/contacts/modals/modals.module';

import { ProjectDialogOverviewPanelComponent } from './overview/overview.component';
import { ProjectDialogCommentsPanelComponent } from './comments/comments.component';
import { ProjectDialogTasksPanelComponent } from './tasks/tasks.component';
import { ProjectDialogFilesPanelComponent } from './files/files.component';
import { ProjectDialogPropertiesPanelComponent } from './properties/properties.component';

import { ProjectDialogDateDropdownComponent } from './components/date-dropdown/date-dropdown.component';
import { ProjectDialogUserDropdownComponent } from './components/user-dropdown/user-dropdown.component';
import { ProjectDialogFullUserDropdownComponent } from './components/full-user-dropdown/full-user-dropdown.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { environment } from '@env/environment';

@NgModule({
  declarations: [
    ProjectDialogCommentsPanelComponent,
    ProjectDialogTasksPanelComponent,
    ProjectDialogFilesPanelComponent,
    ProjectDialogOverviewPanelComponent,
    ProjectDialogDateDropdownComponent,
    ProjectDialogUserDropdownComponent,
    ProjectDialogPropertiesPanelComponent,
    ProjectDialogFullUserDropdownComponent,
  ],
  imports: [
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    NgxMaterialTimepickerModule,
    ContactsModalModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    NgxFilesizeModule,
    MatTooltipModule,
    TreoAutogrowModule,
    MatAutocompleteModule,
    TreoFindByKeyPipeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TreoCardModule,
    SharedModule,
    CurrencyMaskModule,
    NgxMapboxGLModule.withConfig({ accessToken: environment.mapbox.accessToken }),
  ],
  exports: [
    ProjectDialogCommentsPanelComponent,
    ProjectDialogTasksPanelComponent,
    ProjectDialogFilesPanelComponent,
    ProjectDialogOverviewPanelComponent,
    ProjectDialogDateDropdownComponent,
    ProjectDialogUserDropdownComponent,
    ProjectDialogPropertiesPanelComponent,
    ProjectDialogFullUserDropdownComponent,
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class ProjectDialogPanelsModule {}
